//*Lista de articulos los que se pude adquirir para el hogar *//
//===================================
// PLP / Lista de articulos / productos

import useFunctionInfo from "@/Hooks/useDataInformation/useFunctionInfo";
import { ListBrand } from "@/Mappers/ListBrand.mapper";
import { ListProductBuy } from "@/Mappers/ListPorductBuy.mapper";
import { MapperButtons } from "@/Mappers/MapperButtonSubCategories";
import type { BrandsSelected } from "@/Models/MBrand/BrandsSelected";
import type { DataProducts } from "@/Models/MPLP/DataProducts";
import type {
  MSubCategoryHijaSubcategoryV2,
} from "@/Models/MSubCategories/MPLPCategory";
import type { SubCategories } from "@/Models/MSubCategories/SubCategories";
//import { ReplaceCharacter } from "@/Utils/RemplaceCharacter";
import { useEffect, useState } from "react";

export const useProductsByCategory = (
  category: string,
  subCategory: string,
  categFather?: string
) => {
  //lista de productos / articulos
  //const [DatasProducts, setDatasProducts] = useState<DataProducts[]>([]);
  const [DatasProducts, setDatasProducts] = useState<DataProducts[]>([]);
  //Lista de marcas por productos / articulos
  const [DatasMarcas, setDatasMarcas] = useState<BrandsSelected[]>([]);
  //cargando el skeleton
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // const { data: productosInfo, loading: isLoadings } = useFunctionInfo<
  //   products[]
  // >(`/VerCategorias?category=${subCategory}`);
  const { data: productosInfo = [], loading: isLoadings } = useFunctionInfo<
    MSubCategoryHijaSubcategoryV2[]
  >(`/DepartementCategories?subcategory=${categFather}`);

  //console.log("productosInfo", productosInfo);

  useEffect(() => {
    setIsLoading(true);

    const productInfo = Array.isArray(productosInfo) ? productosInfo.length : 0;
    const productInfoData = Array.isArray(productosInfo) ? productosInfo : [];

    ////solo ejecutamos el setTimeout si ya se cargaron los datos.
    if (!isLoadings && productInfo > 0) {
      const timers = setTimeout(async () => {
        ////data mapping for products
        const resultMapper = await ListProductBuy(
          productInfoData,
          category,
          subCategory!
        );
        setDatasProducts(resultMapper);
        //data mapping for brands
        const responseBrand = await ListBrand(
          productInfoData,
          category,
          subCategory!
        );
        setDatasMarcas(responseBrand);
        //loading
        setIsLoading(isLoadings);
      }, 2000);

      return () => clearTimeout(timers);
    }
  }, [productosInfo, isLoadings, subCategory]);

  return {
    DatasProducts,
    DatasMarcas,
    isLoading,
  };
};

// =================================================================

export const useSubCategory = (category: string, categFather: string) => {
  //lista de sub-categoria por categoria
  const [listSubCategory, setlistSubCategory] = useState<SubCategories[]>([]);
  //cargando el skeleton
  const [isLoadingCategory, setIsLoadingCategory] = useState<boolean>(true);
  //llamamos a la funcion para obtener las sub-categorias
  // const { data: subCategorys, loading: isLoadings } = useFunctionInfo<
  //   SubCategories[]
  // >(`/Categorias?name=${ReplaceCharacter(category)}`);
  const { data: productosInfo, loading: isLoadings } = useFunctionInfo<
    MSubCategoryHijaSubcategoryV2[]
  >(`/DepartementCategories?subcategory=${categFather}`);

  //reacciona cuando cambia la data o el loading
  useEffect(() => {
    const productInfo = Array.isArray(productosInfo) ? productosInfo.length : 0;
    const productInfoData = Array.isArray(productosInfo) ? productosInfo : [];
    if (!isLoadings && productInfo) {
      const timer = setTimeout(async () => {
        const responseBrand = await MapperButtons(productInfoData, category);
        setlistSubCategory(responseBrand);
        setIsLoadingCategory(isLoadings);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [productosInfo, isLoadings]);

  return {
    listSubCategory,
    isLoadingCategory,
  };
};
